import type { ReactNode } from "react";
import { StyledLabel, StyledSkeletonInput, StyledSkeletonLabel } from "./FormSkeleton.styles";

type Props = {
  label?: ReactNode;
};

export const FormSkeleton = ({ label }: Props) => (
  <>
    {label ? <StyledLabel>{label}</StyledLabel> : <StyledSkeletonLabel active size="small" />}
    <StyledSkeletonInput active />
  </>
);
